import Vuex from 'vuex'
import Vue from 'vue'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    loaded: false,
    failedFetch: false,
    allowSuggestions: false,
    rounds: [],
    categories: [],
    nominees: [],
    selected: [],
    votes: [],
    suggestions: [],
  },
  actions,
  getters,
  mutations,
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js